/**
 *
 * TCFModal
 *
 */

import React, { useCallback } from 'react';
import classNames from 'classnames';
import { useTranslation } from "react-i18next";

// styles
import './style.scss';

// antd component
import { Modal, Button } from 'antd';

// icons
import CustomIcons from 'components/CustomIcons';

// components
import ErrorBoundary from 'engine/ErrorBoundary';

function TCFModal({
  open,
  loading,
  confirmLoading,
  // states
  title,
  cancelName,
  submitName,
  closable,
  // actions
  setOpen,
  onOk,
  onClose,
  onCancel,
  // default props
  className,
  wrapClassName,
  children,
  ...rest
}) {
  const childClassNames = classNames('tcf-modal', className);
  const { t } = useTranslation();

  const onCloseHandler = useCallback(() => {
    !!setOpen && setOpen(false);
    !!onClose && onClose();
  }, [onClose, onClose]);
  
  const onCancelHandler = useCallback(() => {
    !!setOpen && setOpen(false);
    !!onCancel && onCancel();
  }, [onCancel, setOpen]);

  const onOkHandler = useCallback(() => {
    !!onOk && onOk();
    // !!setOpen && setOpen(false);
  }, [onOk, setOpen]);

  return (
    <ErrorBoundary>
      <Modal
        {...rest}
        wrapClassName={classNames("tcf-modal-wrapper", wrapClassName)}
        className={childClassNames}
        title={!!title && title || t("common.title")}
        open={open}
        onOk={onOkHandler}
        confirmLoading={confirmLoading}
        onCancel={onCloseHandler}
        closable={closable}
        footer={[
          !!onCancel && (
            <Button
              key="back"
              className="ant-btn-cancel"
              type="default"
              onClick={onCancelHandler}
            >
              {!!cancelName && cancelName || t("common.cancel")}
            </Button>
          ),
          !!onOk && (
            <Button
              key="submit"
              className="ant-btn-submit"
              type="default"
              loading={loading}
              onClick={onOkHandler}
            >
              {!!submitName && submitName || t("common.add")}
            </Button>
          ),
        ]}
      >
        {children}
      </Modal>
    </ErrorBoundary>
  );
}

TCFModal.defaultProps = {
  closable: false
};

export default TCFModal;
